"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteExportDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const site_export_json_1 = require("./site-export-json");
exports.SiteExportDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('SiteExport', site_export_json_1.SiteExportJsonMapper);
